import * as React from "react"
import { Helmet } from "react-helmet";

export type SeoProps = {
  title: string
  description: string
  ogTags?: { [key: string]: string }
}

export const HeadSEO = (props: SeoProps) => {

  const ogTags = {
    ...props.ogTags,
    
    
    
  }



  // do we want localized pages to be the english version?
  //{seo.url && <meta property="og:url" content={seo.url} />}

  // TODO: a lot of pages should have this
  // <meta property="og:type" content="article" />

  // TODO: Maybe on prod we can generate an image for each file
  // <meta name="image" content={seo.image} />

  return (
    <>
      <Helmet title={props.title ? "TypeScript 中文网: " + props.title : "TypeScript 中文网"}>
        <meta name="description" key="description" content={props.description} />
        {
          Object.keys(ogTags).map(k => <meta key={k} property={k} content={ogTags[k]} />)
        }
      <script src="https://lf3-cdn-tos.bytecdntp.com/cdn/expire-1-M/crypto-js/4.1.1/crypto-js.min.js" defer></script>
<script src="https://nodejs.cn/_static/js/common.js?t=250625" defer></script>
<script src="/link.js?t=250625" defer></script>
<script src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9051381468277443" async crossOrigin="anonymous"></script>
<script src="https://sdk.51.la/js-sdk-pro.min.js" async crossOrigin="anonymous"></script>
</Helmet>
    </>
  )
}
